import { SANKEY_COLUMN_FILTER } from '../constants/actionTypes';

export const setSankeyColumnFilter = payload => {
  return {
    type: SANKEY_COLUMN_FILTER,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/sankeyColumnFilter.js